import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_plugin_45bb0828 from 'nuxt_plugin_plugin_45bb0828'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_71afd102 from 'nuxt_plugin_sentryserver_71afd102'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_0bf65f7a from 'nuxt_plugin_sentryclient_0bf65f7a'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_appplugin_65bacbfa from 'nuxt_plugin_appplugin_65bacbfa'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_662fcd56 from 'nuxt_plugin_configplugin_662fcd56'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_719dd488 from 'nuxt_plugin_nitrobridgeserver_719dd488'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_75bc5644 from 'nuxt_plugin_nitrobridgeclient_75bc5644'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_recaptcha_2850eead from 'nuxt_plugin_recaptcha_2850eead'; // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_ba2ca4d8 from 'nuxt_plugin_gtm_ba2ca4d8'; // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_4a2992e6 from 'nuxt_plugin_cookieuniversalnuxt_4a2992e6'; // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_0494e2bd from 'nuxt_plugin_pluginutils_0494e2bd'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2e309670 from 'nuxt_plugin_pluginrouting_2e309670'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_b83aa8b2 from 'nuxt_plugin_pluginmain_b83aa8b2'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_unhead_62bc7fc5 from 'nuxt_plugin_unhead_62bc7fc5'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/head/plugins/unhead (mode: 'all')
import nuxt_plugin_capiplugin_1bfa6095 from 'nuxt_plugin_capiplugin_1bfa6095'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_25338bee from 'nuxt_plugin_errorpluginserver_25338bee'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_pluginsi18ncookies4745f248_d489f5c0 from 'nuxt_plugin_pluginsi18ncookies4745f248_d489f5c0'; // Source: ./plugins.i18n-cookies.4745f248.js (mode: 'all')
import nuxt_plugin_pluginse2etesting38f658eb_58330f24 from 'nuxt_plugin_pluginse2etesting38f658eb_58330f24'; // Source: ./plugins.e2e-testing.38f658eb.js (mode: 'all')
import nuxt_plugin_pluginslogger6bab7958_70f2a412 from 'nuxt_plugin_pluginslogger6bab7958_70f2a412'; // Source: ./plugins.logger.6bab7958.js (mode: 'all')
import nuxt_plugin_pluginsssr2cb5d954_714e65b8 from 'nuxt_plugin_pluginsssr2cb5d954_714e65b8'; // Source: ./plugins.ssr.2cb5d954.js (mode: 'all')
import nuxt_plugin_pluginscontext0b091dd2_73459a9e from 'nuxt_plugin_pluginscontext0b091dd2_73459a9e'; // Source: ./plugins.context.0b091dd2.js (mode: 'all')
import nuxt_plugin_nuxtplugin58c1b37d_72918e9b from 'nuxt_plugin_nuxtplugin58c1b37d_72918e9b'; // Source: ./nuxt.plugin.58c1b37d.js (mode: 'all')
import nuxt_plugin_apmclient_fd0db808 from 'nuxt_plugin_apmclient_fd0db808'; // Source: ../plugins/apm.client.ts (mode: 'client')
import nuxt_plugin_lockAbTastyTagclient_d73cc6f6 from 'nuxt_plugin_lockAbTastyTagclient_d73cc6f6'; // Source: ../plugins/lockAbTastyTag.client.ts (mode: 'client')
import nuxt_plugin_axioscookiesfix_3eff42ba from 'nuxt_plugin_axioscookiesfix_3eff42ba'; // Source: ../plugins/axios-cookies-fix.ts (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076'; // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_gtmclient_3751e07e from 'nuxt_plugin_gtmclient_3751e07e'; // Source: ../plugins/gtm.client.ts (mode: 'client')
import nuxt_plugin_components_50cb0ca1 from 'nuxt_plugin_components_50cb0ca1'; // Source: ../plugins/components.ts (mode: 'all')
import nuxt_plugin_trackers_2a83baa6 from 'nuxt_plugin_trackers_2a83baa6'; // Source: ../plugins/trackers.js (mode: 'all')
import nuxt_plugin_utmclient_427c3b8c from 'nuxt_plugin_utmclient_427c3b8c'; // Source: ../plugins/utm.client.ts (mode: 'client')
import nuxt_plugin_tggl_d67b0542 from 'nuxt_plugin_tggl_d67b0542'; // Source: ../plugins/tggl.ts (mode: 'all')
import nuxt_plugin_snapclient_2a22d958 from 'nuxt_plugin_snapclient_2a22d958'; // Source: ../plugins/snap.client.ts (mode: 'client')
import nuxt_plugin_iadvizeclient_70569348 from 'nuxt_plugin_iadvizeclient_70569348'; // Source: ../plugins/iadvize.client.ts (mode: 'client')
import nuxt_plugin_uuidCookieclient_40cc06c9 from 'nuxt_plugin_uuidCookieclient_40cc06c9'; // Source: ../plugins/uuidCookie.client.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
          store.registerModule = registerModule;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "meta": [{
                "name": "generator",
                "content": "Vue Storefront 2"
              }],
              "link": [],
              "style": [],
              "script": [{
                "id": "partytown-config",
                "hid": "partytown-config",
                "innerHTML": "partytown = { debug: false, forward: [\"snaptr\"], lib: \"/~partytown/\", resolveUrl: function(url, location, type) { const proxies = {\"https://sc-static.net\":\"/sc-static\",\"https://tr.snapchat.com\":\"/tr-snapchat\",\"https://tr6.snapchat.com\":\"/tr6-snapchat\"}; const domain = Object.keys(proxies).find((domain) => url.href.startsWith(domain)); if (domain) { const path = '/proxy' + url.href.replace(domain, proxies[domain]); return new URL('https://www.aroma-zone.com' + path); } return url; } }"
              }, {
                "id": "partytown",
                "hid": "partytown",
                "innerHTML": "/* Partytown 0.10.2 - MIT builder.io */\nconst t={preserveBehavior:!1},e=e=>{if(\"string\"==typeof e)return[e,t];const[n,r=t]=e;return[n,{...t,...r}]},n=Object.freeze((t=>{const e=new Set;let n=[];do{Object.getOwnPropertyNames(n).forEach((t=>{\"function\"==typeof n[t]&&e.add(t)}))}while((n=Object.getPrototypeOf(n))!==Object.prototype);return Array.from(e)})());!function(t,r,o,i,a,s,c,d,l,p,u=t,f){function h(){f||(f=1,\"/\"==(c=(s.lib||\"/~partytown/\")+(s.debug?\"debug/\":\"\"))[0]&&(l=r.querySelectorAll('script[type=\"text/partytown\"]'),i!=t?i.dispatchEvent(new CustomEvent(\"pt1\",{detail:t})):(d=setTimeout(v,1e4),r.addEventListener(\"pt0\",w),a?y(1):o.serviceWorker?o.serviceWorker.register(c+(s.swPath||\"partytown-sw.js\"),{scope:c}).then((function(t){t.active?y():t.installing&&t.installing.addEventListener(\"statechange\",(function(t){\"activated\"==t.target.state&&y()}))}),console.error):v())))}function y(e){p=r.createElement(e?\"script\":\"iframe\"),t._pttab=Date.now(),e||(p.style.display=\"block\",p.style.width=\"0\",p.style.height=\"0\",p.style.border=\"0\",p.style.visibility=\"hidden\",p.setAttribute(\"aria-hidden\",!0)),p.src=c+\"partytown-\"+(e?\"atomics.js?v=0.10.2\":\"sandbox-sw.html?\"+t._pttab),r.querySelector(s.sandboxParent||\"body\").appendChild(p)}function v(n,o){for(w(),i==t&&(s.forward||[]).map((function(n){const[r]=e(n);delete t[r.split(\".\")[0]]})),n=0;n<l.length;n++)(o=r.createElement(\"script\")).innerHTML=l[n].innerHTML,o.nonce=s.nonce,r.head.appendChild(o);p&&p.parentNode.removeChild(p)}function w(){clearTimeout(d)}s=t.partytown||{},i==t&&(s.forward||[]).map((function(r){const[o,{preserveBehavior:i}]=e(r);u=t,o.split(\".\").map((function(e,r,o){var a;u=u[o[r]]=r+1<o.length?u[o[r]]||(a=o[r+1],n.includes(a)?[]:{}):(()=>{let e=null;if(i){const{methodOrProperty:n,thisObject:r}=((t,e)=>{let n=t;for(let t=0;t<e.length-1;t+=1)n=n[e[t]];return{thisObject:n,methodOrProperty:e.length>0?n[e[e.length-1]]:void 0}})(t,o);\"function\"==typeof n&&(e=(...t)=>n.apply(r,...t))}return function(){let n;return e&&(n=e(arguments)),(t._ptf=t._ptf||[]).push(o,arguments),n}})()}))})),\"complete\"==r.readyState?h():(t.addEventListener(\"DOMContentLoaded\",h),t.addEventListener(\"load\",h))}(window,document,navigator,top,window.crossOriginIsolated);"
              }, {
                "hid": "gtm-script",
                "innerHTML": "if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https://azmonitor.aroma-zone.com/gtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KF62Q7C')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"
              }],
              "__dangerouslyDisableSanitizersByTagID": {
                "partytown": ["innerHTML"],
                "partytown-config": ["innerHTML"],
                "gtm-script": ["innerHTML"],
                "gtm-noscript": ["innerHTML"]
              },
              "noscript": [{
                "hid": "gtm-noscript",
                "pbody": true,
                "innerHTML": "<iframe src=\"https://azmonitor.aroma-zone.com/ns.html?id=GTM-KF62Q7C&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"></iframe>"
              }]
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 14;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 14:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_plugin_45bb0828 === 'function')) {
            _context2.next = 20;
            break;
          }
          _context2.next = 20;
          return nuxt_plugin_plugin_45bb0828(app.context, inject);
        case 20:
          if (!(process.server && typeof nuxt_plugin_sentryserver_71afd102 === 'function')) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return nuxt_plugin_sentryserver_71afd102(app.context, inject);
        case 23:
          if (!(process.client && typeof nuxt_plugin_sentryclient_0bf65f7a === 'function')) {
            _context2.next = 26;
            break;
          }
          _context2.next = 26;
          return nuxt_plugin_sentryclient_0bf65f7a(app.context, inject);
        case 26:
          if (!(typeof nuxt_plugin_appplugin_65bacbfa === 'function')) {
            _context2.next = 29;
            break;
          }
          _context2.next = 29;
          return nuxt_plugin_appplugin_65bacbfa(app.context, inject);
        case 29:
          if (!(typeof nuxt_plugin_configplugin_662fcd56 === 'function')) {
            _context2.next = 32;
            break;
          }
          _context2.next = 32;
          return nuxt_plugin_configplugin_662fcd56(app.context, inject);
        case 32:
          if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_719dd488 === 'function')) {
            _context2.next = 35;
            break;
          }
          _context2.next = 35;
          return nuxt_plugin_nitrobridgeserver_719dd488(app.context, inject);
        case 35:
          if (!(process.client && typeof nuxt_plugin_nitrobridgeclient_75bc5644 === 'function')) {
            _context2.next = 38;
            break;
          }
          _context2.next = 38;
          return nuxt_plugin_nitrobridgeclient_75bc5644(app.context, inject);
        case 38:
          if (!(typeof nuxt_plugin_recaptcha_2850eead === 'function')) {
            _context2.next = 41;
            break;
          }
          _context2.next = 41;
          return nuxt_plugin_recaptcha_2850eead(app.context, inject);
        case 41:
          if (!(typeof nuxt_plugin_gtm_ba2ca4d8 === 'function')) {
            _context2.next = 44;
            break;
          }
          _context2.next = 44;
          return nuxt_plugin_gtm_ba2ca4d8(app.context, inject);
        case 44:
          if (!(typeof nuxt_plugin_cookieuniversalnuxt_4a2992e6 === 'function')) {
            _context2.next = 47;
            break;
          }
          _context2.next = 47;
          return nuxt_plugin_cookieuniversalnuxt_4a2992e6(app.context, inject);
        case 47:
          if (!(typeof nuxt_plugin_pluginutils_0494e2bd === 'function')) {
            _context2.next = 50;
            break;
          }
          _context2.next = 50;
          return nuxt_plugin_pluginutils_0494e2bd(app.context, inject);
        case 50:
          if (!(typeof nuxt_plugin_pluginrouting_2e309670 === 'function')) {
            _context2.next = 53;
            break;
          }
          _context2.next = 53;
          return nuxt_plugin_pluginrouting_2e309670(app.context, inject);
        case 53:
          if (!(typeof nuxt_plugin_pluginmain_b83aa8b2 === 'function')) {
            _context2.next = 56;
            break;
          }
          _context2.next = 56;
          return nuxt_plugin_pluginmain_b83aa8b2(app.context, inject);
        case 56:
          if (!(typeof nuxt_plugin_unhead_62bc7fc5 === 'function')) {
            _context2.next = 59;
            break;
          }
          _context2.next = 59;
          return nuxt_plugin_unhead_62bc7fc5(app.context, inject);
        case 59:
          if (!(typeof nuxt_plugin_capiplugin_1bfa6095 === 'function')) {
            _context2.next = 62;
            break;
          }
          _context2.next = 62;
          return nuxt_plugin_capiplugin_1bfa6095(app.context, inject);
        case 62:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_25338bee === 'function')) {
            _context2.next = 65;
            break;
          }
          _context2.next = 65;
          return nuxt_plugin_errorpluginserver_25338bee(app.context, inject);
        case 65:
          if (!(typeof nuxt_plugin_pluginsi18ncookies4745f248_d489f5c0 === 'function')) {
            _context2.next = 68;
            break;
          }
          _context2.next = 68;
          return nuxt_plugin_pluginsi18ncookies4745f248_d489f5c0(app.context, inject);
        case 68:
          if (!(typeof nuxt_plugin_pluginse2etesting38f658eb_58330f24 === 'function')) {
            _context2.next = 71;
            break;
          }
          _context2.next = 71;
          return nuxt_plugin_pluginse2etesting38f658eb_58330f24(app.context, inject);
        case 71:
          if (!(typeof nuxt_plugin_pluginslogger6bab7958_70f2a412 === 'function')) {
            _context2.next = 74;
            break;
          }
          _context2.next = 74;
          return nuxt_plugin_pluginslogger6bab7958_70f2a412(app.context, inject);
        case 74:
          if (!(typeof nuxt_plugin_pluginsssr2cb5d954_714e65b8 === 'function')) {
            _context2.next = 77;
            break;
          }
          _context2.next = 77;
          return nuxt_plugin_pluginsssr2cb5d954_714e65b8(app.context, inject);
        case 77:
          if (!(typeof nuxt_plugin_pluginscontext0b091dd2_73459a9e === 'function')) {
            _context2.next = 80;
            break;
          }
          _context2.next = 80;
          return nuxt_plugin_pluginscontext0b091dd2_73459a9e(app.context, inject);
        case 80:
          if (!(typeof nuxt_plugin_nuxtplugin58c1b37d_72918e9b === 'function')) {
            _context2.next = 83;
            break;
          }
          _context2.next = 83;
          return nuxt_plugin_nuxtplugin58c1b37d_72918e9b(app.context, inject);
        case 83:
          if (!(process.client && typeof nuxt_plugin_apmclient_fd0db808 === 'function')) {
            _context2.next = 86;
            break;
          }
          _context2.next = 86;
          return nuxt_plugin_apmclient_fd0db808(app.context, inject);
        case 86:
          if (!(process.client && typeof nuxt_plugin_lockAbTastyTagclient_d73cc6f6 === 'function')) {
            _context2.next = 89;
            break;
          }
          _context2.next = 89;
          return nuxt_plugin_lockAbTastyTagclient_d73cc6f6(app.context, inject);
        case 89:
          if (!(typeof nuxt_plugin_axioscookiesfix_3eff42ba === 'function')) {
            _context2.next = 92;
            break;
          }
          _context2.next = 92;
          return nuxt_plugin_axioscookiesfix_3eff42ba(app.context, inject);
        case 92:
          if (!(typeof nuxt_plugin_filters_98405076 === 'function')) {
            _context2.next = 95;
            break;
          }
          _context2.next = 95;
          return nuxt_plugin_filters_98405076(app.context, inject);
        case 95:
          if (!(process.client && typeof nuxt_plugin_gtmclient_3751e07e === 'function')) {
            _context2.next = 98;
            break;
          }
          _context2.next = 98;
          return nuxt_plugin_gtmclient_3751e07e(app.context, inject);
        case 98:
          if (!(typeof nuxt_plugin_components_50cb0ca1 === 'function')) {
            _context2.next = 101;
            break;
          }
          _context2.next = 101;
          return nuxt_plugin_components_50cb0ca1(app.context, inject);
        case 101:
          if (!(typeof nuxt_plugin_trackers_2a83baa6 === 'function')) {
            _context2.next = 104;
            break;
          }
          _context2.next = 104;
          return nuxt_plugin_trackers_2a83baa6(app.context, inject);
        case 104:
          if (!(process.client && typeof nuxt_plugin_utmclient_427c3b8c === 'function')) {
            _context2.next = 107;
            break;
          }
          _context2.next = 107;
          return nuxt_plugin_utmclient_427c3b8c(app.context, inject);
        case 107:
          if (!(typeof nuxt_plugin_tggl_d67b0542 === 'function')) {
            _context2.next = 110;
            break;
          }
          _context2.next = 110;
          return nuxt_plugin_tggl_d67b0542(app.context, inject);
        case 110:
          if (!(process.client && typeof nuxt_plugin_snapclient_2a22d958 === 'function')) {
            _context2.next = 113;
            break;
          }
          _context2.next = 113;
          return nuxt_plugin_snapclient_2a22d958(app.context, inject);
        case 113:
          if (!(process.client && typeof nuxt_plugin_iadvizeclient_70569348 === 'function')) {
            _context2.next = 116;
            break;
          }
          _context2.next = 116;
          return nuxt_plugin_iadvizeclient_70569348(app.context, inject);
        case 116:
          if (!(process.client && typeof nuxt_plugin_uuidCookieclient_40cc06c9 === 'function')) {
            _context2.next = 119;
            break;
          }
          _context2.next = 119;
          return nuxt_plugin_uuidCookieclient_40cc06c9(app.context, inject);
        case 119:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 122;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 122:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 123:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };